import {Card} from "flowbite-react";
import Chart from "react-apexcharts";
import React, {useContext} from "react";
import {moment} from "../../../services/moment-extensions";
import {AuthContext} from "../../../context/AuthContext";
import {QuestionCircle} from "flowbite-react-icons/outline";
import Tooltip from "../../Common/Tooltip";
import {VENDOR_CHART_IS_ESSENTIAL} from "../../../services/constants/VendorDashboardPackages";

const EMPTY_STRING = '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0';

const getChartTooltip = (props, markerIndex, mode, seriesLabels) => {


    if (markerIndex >= 0 && props.seriesIndex === 0 && props.dataPointIndex === markerIndex)
        return `<div
        class="flex flex-col sl-border-radius-8 sl-bg-gray-900 sl-p-3 sl-w-fit-content sl-align-flex-start sl-gap-1">
        <span class="sl-text-xs sl-font-semibold sl-text-white ">Day you bought Essentials</span>
    </div>`;

    const currentDate = props.w.globals.categoryLabels[props.dataPointIndex];
    let dateLabel = ''
    if (mode === 'week') {
        dateLabel = currentDate;
    }

    if (mode === 'month') {
        dateLabel = currentDate;
    }

    let serie1Value = props.series[0][props.dataPointIndex];

    //check if float limit to 1 decimal place
    if (!Number.isInteger(serie1Value)) {
        serie1Value = serie1Value?.toFixed(1);
    }

    let serie2Value = props.series[1][props.dataPointIndex];

    //check if float limit to 1 decimal place
    if (!Number.isInteger(serie2Value)) {
        serie2Value = serie2Value?.toFixed(1);
    }

    return `<div
        class="flex flex-col sl-border-radius-8 sl-bg-gray-900 sl-p-3 sl-w-fit-content sl-align-flex-start sl-gap-1">

        <span class="sl-text-xs sl-font-semibold sl-text-white "> ${dateLabel}</span>
        <div class="flex flex-col sl-align-flex-start sl-gap-1">
            
            <span class="sl-font-regular sl-text-sm sl-text-gray-300 flex flex-row sl-gap-2">
            
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" class="sl-m-auto">
                <circle cx="4" cy="4" r="4" fill="${props.w.config.series[0].color}"/>
            </svg>
            ${seriesLabels[0]}: <span
                class="sl-font-semibold sl-text-white">${serie1Value}</span></span>
           
            <span class="sl-font-regular sl-text-sm sl-text-gray-300 flex flex-row sl-gap-2">
            
                 <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"  class="sl-m-auto">
                        <circle cx="4" cy="4" r="4" fill="${props.w.config.series[1].color}"/>
                 </svg>

            ${seriesLabels[1]}: <span
                class="sl-font-semibold sl-text-white">${serie2Value}</span></span>
        </div>
    </div>`
}

const formatChartData = (data = [], essentialsDate = null, mode, seriesLabels) => {
    const line1Data = [];
    const line2Data = [];
    const labels = [];
    const markerIndex = data?.findIndex((item) => moment(item.date).isSame(essentialsDate, 'day'));
    let max = 0;


    data?.map((item) => {
        line1Data.push(item.vendor_data);
        line2Data.push(item.others_data);
        // labels.push(moment(item.date).format('MMM DD'));

        let dateLabel = '';
        if (mode === 'week') {
            dateLabel = `${!labels.length ? EMPTY_STRING : ''}${moment(item.date).toChartLabel()} - ${moment(item.date).add(6, 'days').toChartLabel()}`;
        }

        if (mode === 'month') {
            dateLabel = `${!labels.length ? EMPTY_STRING : ''}${moment(item.checkMonth).startOf('month').toChartLabel()} - ${moment(item.checkMonth).endOf('month').toChartLabel()}`;
        }

        labels.push(dateLabel);

        if (item.vendor_data > max) {
            max = item.vendor_data;
        }
        if (item.others_data > max) {
            max = item.others_data;
        }
        return true
    });


    return {
        series: [

            {
                name: seriesLabels[0],
                type: 'line',
                data: line1Data,
                color: "#2E90FA",
            }, {
                name: seriesLabels[1],
                type: 'line',
                data: line2Data,
                color: "#12B76A"
            }
        ],
        options: {

            chart: {
                height: 350,
                type: 'line',
                toolbar: {
                    show: false,
                },
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                show: false
            },
            stroke: {
                width: [2, 2],
                curve: ['smooth', 'smooth']
            },
            tooltip: {
                shared: true,
                intersect: false,
                custom: function (props) {
                    return getChartTooltip(props, markerIndex, mode, seriesLabels);
                },
            },
            markers: {
                strokeWidth: 2,
                size: 5, // Size of the markers
                colors: ['#fff'], // Color of the markers
                strokeColors: ['#2E90FA', '#12B76A'], // Border color of the markers
                hover: {
                    size: 4, // Size of the markers on hover
                    sizeOffset: 3 // Offset size on hover
                },
                shape: 'circle',// Shape
                discrete: [
                    {seriesIndex: 0, dataPointIndex: markerIndex, size: 5, fillColor: '#fff', strokeColor: '#2E90FA'},
                ]
            },
            xaxis: {
                categories: labels,
                labels: {
                    rotateAlways: true,
                    rotate: -45, // Rotate X-axis labels by -45 degrees
                },
                tooltip: {
                    enabled: false,

                },
            },
            yaxis: {
                //add tickAmount conditionally  if max is less than 5
                tickAmount: max < 10 ? max : undefined,
                labels: {
                    formatter: function (value) {
                        if (Number.isInteger(value)) {
                            return value.toString(); // Convert integer to string
                        } else {
                            return value.toFixed(1); // Limit float to 1 decimal places
                        }
                    }
                }

            }
        },
    };
}


const VendorDashboardChart = ({isLoaded, chartData, essentialsDate, mode, seriesLabels}) => {

    const {company, baseUrl} = useContext(AuthContext);
    const essentialsUrl = `${baseUrl}/plan-and-payment-settings/plans-and-pricing`;

    let legendTooltip = <span>Vendors who participate in the Shortlister <a className={"sl-underline"}
                                                                            href={essentialsUrl}>Essentials</a> program, providing an upgraded profile for brokers to see and share with their team or client.</span>

    if (company?.[VENDOR_CHART_IS_ESSENTIAL]) {
        seriesLabels[1] = 'Non-Essentials'
        legendTooltip = 'Your firm participated in the Shortlister Essentials program to enhance your profile.  These vendors do not participate in Essentials.'
    }

    const formattedData = formatChartData(chartData, essentialsDate, mode, seriesLabels);

    return <React.Fragment>
        <Card>
            <div className={"sl-flex sl-flex-row justify-end sl-gap-3"}>
                {seriesLabels.map((name, index) => {
                    const isEssential = name.toLowerCase().includes('essentials');
                    const isLink = isEssential && !company?.[VENDOR_CHART_IS_ESSENTIAL];

                    const labelText = isLink ?
                        <a className={"sl-underline"} href={essentialsUrl}>Essentials</a> : name;

                    return <div className={"sl-flex sl-flex-row sl-gap-2 sl-items-center"}>
                        <div className={"sl-w-3 sl-h-3 sl-rounded-full"}
                             style={{backgroundColor: !isEssential ? "#2E90FA" : "#12B76A"}}/>
                        <span
                            className={`sl-text-gray-600 sl-font-inter sl-text-sm sl-font-normal ${isLink ? 'sl-text-hover-gray-700 sl-text-hover-underline' : ''}`}>{labelText}</span>
                        {index === 1 &&
                            <span className={"cursor-pointer"}><Tooltip content={legendTooltip}><QuestionCircle
                                color={"#98A2B3"} size={20}/></Tooltip></span>}
                    </div>


                })}
            </div>
            <div className={"sl-relative"}>
                <div style={{opacity: isLoaded ? 1 : 0}}>
                    <Chart options={formattedData.options} series={formattedData.series} type="line"
                           height={350}/>
                </div>

                {!isLoaded && <div
                    className={"sl-absolute sl-m-auto sl-right-0 sl-left-0 sl-top-0 sl-bottom-0 sl-flex sl-flex-col sl-gap-4 sl-h-20"}>
                    <div className="sl-loader sl-m-auto "/>
                    <span className={"sl-text-gray-700 sl-text-center sl-font-medium sl-text-sm "}>Loading...</span>
                </div>}
            </div>
        </Card>
    </React.Fragment>
}

export default VendorDashboardChart;